export default class Env {
    public static LOCAL = 'local';
    public static STAGING = 'staging';
    public static PROD = 'prod';
}
